const orderSourceVariants = [
  { id: "EDI", name: "EDI" },
  { id: "batchjob", name: "Batch Job" },
  { id: "form", name: "Form" }
];

export { orderSourceVariants };
